import { axios } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import { AccessControlService } from './access-control'
import { AuditLogService } from './audit-log'
import { AutoBanService } from './auto-ban'
import { EquipmentService } from './equipment'
import { AccountingAndTaxService } from './accounting-and-tax'
import { AuthenticationService } from './authentication'
import { BranchService } from './branch'
import { BundleService } from './bundle'
import { CampaignService } from './campaign'
import { SwimmingBookingService } from './bookings/swimming-booking.service'
import { CheckinService } from './checkin'
import { ClassService } from './class'
import { ClassSummaryService } from './class-summary'
import { ClubInfoService } from './club-info'
import { DocusignService } from './docusign'
import { EmailChangeService } from './email-change'
import { ESignatureService } from './e-signature'
import { FacilitiesService } from './facility'
import { GoalSettingService } from './goal-setting'
import { IndividualSaleSummaryService } from './individual-sale-summary'
import { LeadService } from './lead'
import { LeadFormService } from './lead-form'
import { LeadGenerationService } from './lead-generation'
import { TenantLookupService } from './tenant-lookup'
import { MasterDataService } from './masterData'
import { McpOAuthService } from './mcp-oauth'
import { MemberService } from './member'
import { MemberFeedbackService } from './member-feedback'
import { MemberFreezeService } from './member-freeze'
import { MemberTagService } from './member-tag'
import { PackageService } from './package'
import { CreditService } from './credit'
import { CreditSummaryService } from './credit-summary'
import { LoyaltyService } from './loyalty'
import { PosService } from './pos'
import { ProductService } from './products'
import { MarketplaceService } from './marketplace'
import { ReceiptService } from './receipt'
import { RenewalForecastService } from './renewal-forecast'
import { RevenueBreakdownService } from './revenue-breakdown'
import { ReportConfigService } from './report-configs'
import { ReportsService } from './reports'
import { RoomService } from './room'
import { SaleService } from './sale'
import { SaleCommissionService } from './sale-commission'
import { SessionUtilizationService } from './session-utilization'
import { SpaService } from './spa'
import { StaffService } from './staff'
import { SwimmingService } from './swimming/swimming.service'
import { TenantClientService } from './tenant-client'
import { TrainerService } from './trainer'
import { TrainerCommissionService } from './trainer-commission'
import { TrainerPerformanceService } from './trainer-performance'
import { TrainerSummaryService } from './trainer-summary'
import { TaxInvoiceService } from './tax-invoice'
import { UpSellService } from './up-sell'
import { UserService } from './user'
import { WorkoutService } from './workout'
import { WorkplaceService } from './workplace'

const Client = (client: AxiosInstance) => {
  return {
    authentication: AuthenticationService(client),
    checkin: CheckinService(client),
    user: UserService(client),
    staff: StaffService(client),
    member: MemberService(client),
    memberFeedback: MemberFeedbackService(client),
    memberFreeze: MemberFreezeService(client),
    memberTag: MemberTagService(client),
    masterData: MasterDataService(client),
    package: PackageService(client),
    bundle: BundleService(client),
    class: ClassService(client),
    receipt: ReceiptService(client),
    reportConfigs: ReportConfigService(client),
    reports: ReportsService(client),
    eSignature: ESignatureService(client),
    credit: CreditService(client),
    loyalty: LoyaltyService(client),
    goalSetting: GoalSettingService(client),
    trainer: TrainerService(client),
    trainerPerformance: TrainerPerformanceService(client),
    docusign: DocusignService(client),
    emailChange: EmailChangeService(client),
    lead: LeadService(client),
    leadForm: LeadFormService(client),
    tenantLookup: TenantLookupService(client),
    sale: SaleService(client),
    room: RoomService(client),
    facilities: FacilitiesService(client),
    spa: SpaService(client),
    leadGeneration: LeadGenerationService(client),
    swimming: SwimmingService(client),
    swimmingBooking: SwimmingBookingService(client),
    upSell: UpSellService(client),
    clubInfo: ClubInfoService(client),
    branch: BranchService(client),
    campaign: CampaignService(client),
    tenantClient: TenantClientService(client),
    product: ProductService(client),
    pos: PosService(client),
    marketplace: MarketplaceService(client),
    accessControl: AccessControlService(client),
    auditLog: AuditLogService(client),
    trainerSummary: TrainerSummaryService(client),
    accountingAndTax: AccountingAndTaxService(client),
    individualSaleSummary: IndividualSaleSummaryService(client),
    classSummary: ClassSummaryService(client),
    creditSummary: CreditSummaryService(client),
    trainerCommission: TrainerCommissionService(client),
    saleCommission: SaleCommissionService(client),
    taxInvoice: TaxInvoiceService(client),
    renewalForecast: RenewalForecastService(client),
    revenueBreakdown: RevenueBreakdownService(client),
    sessionUtilization: SessionUtilizationService(client),
    equipment: EquipmentService(client),
    workplace: WorkplaceService(client),
    mcpOAuth: McpOAuthService(client),
    autoBan: AutoBanService(client),
    workout: WorkoutService(client),
  }
}

const client = Client(axios)
export { client, Client }
